<template>
  <Marco>
    <div slot="content">
      <div class="main-title">
        <h1 class="title">{{ step.pregunta }}</h1>
      </div>

      <div class="field-row">
        <div class="field">
          <p class="label">{{ step.subPregunta }}</p>

          <div class="autotab">
            <div>
              <form @submit.prevent="siguiente()">
                <input
                  title="Dígitos"
                  v-model.trim="numero"
                  type="tel"
                  maxlength="5"
                  class="number long5"
                />
              </form>
            </div>
          </div>
        </div>
        <div v-if="errorNumero" class="noValido">{{ errorNumero }}</div>
      </div>
    </div>

    <a slot="botonAtras" href="#" @click.prevent="$router.go(-1)">Atrás</a>
    <a slot="botonSiguiente" href="#" @click.prevent="siguiente()">
      Siguiente</a
    >
  </Marco>
</template>

<script>
import actions from "@/util/actions.js";

export default {
  store: ["step"],

  data() {
    return {
      numero: "",
      errorNumero: ""
    };
  },

  mounted() {
    this.numero = actions.getSeleccionAnterior(this.$route.params.np);

    let vm = this;
    this.$eventBus.$on("errorServidor", function(mensaje) {
      console.log("Numeros Error devuelto por el servidor: " + mensaje);
      vm.errorNumero = mensaje;
    });
  },

  methods: {
    siguiente: async function() {
      if (this.numero == null) {
        this.errorNumero = "Campo obligatorio";
        return;
      }

      actions.setSeleccion(this.$route.params.np, this.numero);
      console.log("Número:" + this.numero);
      this.$emit("elegido", this.numero);
    }
  }
};
</script>

<style lang="scss" scoped>
.long5 {
  width: 20rem;
}
</style>
